import React from "react";
import { SheetSection, SheetGrid, SheetField, formatText, formatBoolean } from "../SheetLayout";

interface IEntornoLaboral {
  id: string;
  nombre: string;
  CCC: string;
  CIF: string;
  EntornoLaboralEmpresaId: string;
  EsCuentaPropia: boolean;
  NAF: string;
  data?: any;
}

const EntornoLaboral: React.FunctionComponent<IEntornoLaboral> = ({
  nombre,
  CCC,
  CIF,
  EsCuentaPropia,
  NAF,
  data,
}) => {
  const entornos: any[] = data?.entornosLaborales;

  if (entornos && entornos.length > 0) {
    return (
      <>
        {entornos.map((ent: any, i: number) => (
          <SheetSection
            key={i}
            title={ent.EsCuentaPropia ? "Entorno Laboral — Cuenta Propia" : "Entorno Laboral — Cuenta Ajena"}
            icon="briefcase"
          >
            <SheetGrid>
              <SheetField label="Nombre"  value={formatText(ent.Nombre)} wide />
              <SheetField label="CIF"     value={formatText(ent.CIF)} />
              <SheetField label="CCC"     value={formatText(ent.CCC)} />
              {ent.EsCuentaPropia && <SheetField label="NAF" value={formatText(ent.NAF)} />}
            </SheetGrid>
          </SheetSection>
        ))}
      </>
    );
  }

  return (
    <SheetSection title="Entorno Laboral" icon="briefcase">
      <SheetGrid>
        <SheetField label="Nombre"           value={formatText(nombre)} wide />
        <SheetField label="CIF"              value={formatText(CIF)} />
        <SheetField label="CCC"              value={formatText(CCC)} />
        <SheetField label="Es Cuenta Propia" value={formatBoolean(EsCuentaPropia)} />
        <SheetField label="NAF"              value={formatText(NAF)} />
      </SheetGrid>
    </SheetSection>
  );
};

export default EntornoLaboral;
